import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://quzcdexwkptpzzrglwzx.supabase.co'
const supabasePublishableKey = 'sb_publishable_6MVRmy10bxrhxlBZVr2UXQ_LqV5wXE-'

export function createSupabaseClient() {
  return createClient(supabaseUrl, supabasePublishableKey)
}